import i18next, { TOptions } from 'i18next'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { TranslationKeys } from '@/@types/keys/translation'

export default function useTranslator() {
  const { t } = useTranslation()

  const getTranslation = useCallback(
    (key: TranslationKeys, params?: TOptions) => {
      return t(key, params)
    },
    [t],
  )

  function changeLanguage(lang: string) {
    i18next.changeLanguage(lang)
  }

  const currentLang = i18next.language

  return {
    getTranslation,
    changeLanguage,
    currentLang,
  }
}
